import { StockListPage } from './../../../stock/stock-list/stock-list';
import { Globals } from './../../../../globals';
import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { ProvidersServices } from '../../services';
import { getCurrencySymbol } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { ProviderOrderListPage } from '../provider-order-list/provider-order-list';
import { ProvidersCreateDataPage } from '../../providers-create/providers-create-data/providers-create-data';
import { AnalyticsServices } from '../../../services/analyticsServices';

/**
 * Generated class for the ProviderOrderCartPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-provider-order-cart',
  templateUrl: 'provider-order-cart.html',
})
export class ProviderOrderCartPage {
  elements: any;
  providers: any;
  total_providers: any = 0;
  total_order: any = 0;
  cart_loading: boolean = false;
  hasZeroQuantityElements: boolean = false;
  canPlaceOrdersNow: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public providersServices: ProvidersServices,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    public translate: TranslateService,
    public analyticsService: AnalyticsServices) {
    this.globals.GAtrackView('ProviderOrders', 'ProviderOrders - Cart - View', this.globals.restaurant.email, 'View', 'View cart', 'ProviderOrders', '');
  }

  // Verificar si un proveedor específico tiene elementos con cantidad 0
  providerHasZeroQuantityElements(provider_uid: string): boolean {
    if (!this.elements || this.elements.length === 0) {
      return false;
    }

    return this.elements.some(element =>
      element.provider_uid === provider_uid && element.quantity <= 0
    );
  }

  // Verificar si se pueden realizar todos los pedidos (para el botón general)
  canPlaceAllOrders(): boolean {
    if (!this.providers || this.providers.length === 0) {
      return false;
    }

    // Solo considerar proveedores que tienen email para enviar pedidos
    const providersWithEmail = this.providers.filter(provider =>
      provider.email && provider.email.length > 0
    );

    if (providersWithEmail.length === 0) {
      return false;
    }

    // Verificar que ningún proveedor con email tenga elementos con cantidad 0
    return !providersWithEmail.some(provider =>
      this.providerHasZeroQuantityElements(provider.uid)
    );
  }

  checkOrderValidation() {
    if (!this.elements || this.elements.length === 0) {
      this.hasZeroQuantityElements = false;
      this.canPlaceOrdersNow = this.globals.cart_elements > 0;
      return;
    }

    this.hasZeroQuantityElements = this.elements.some(element => element.quantity <= 0);
    this.canPlaceOrdersNow = this.canPlaceAllOrders();
  }

  ionViewWillEnter() {
    this.cart_loading = false;
    if (this.globals.cart_elements > 0) {
      this.getElements();
    } else {
      this.cart_loading = true;
    }
  }

  async getElements() {
    var return_elements = await this.providersServices.getElementsCart(this.globals.restaurant_uid, this.globals.user_uid);
    this.elements = return_elements[0];
    if (this.elements && this.elements.length) {
      this.elements.forEach(element => {
        element.quantity = this.roundQuantity(element.quantity);
      });
    }
    this.providers = return_elements[1];
    this.total_order = return_elements[2];
    this.total_providers = return_elements[3];
    this.providersServices.getTotalCartElements(this.globals.restaurant_uid, this.globals.user_uid);
    this.cart_loading = true;
    this.checkOrderValidation();
  }

  async getElementsAsync() {
    var return_elements = await this.providersServices.getElementsCart(this.globals.restaurant_uid, this.globals.user_uid);
    this.elements = return_elements[0];
    if (this.elements && this.elements.length) {
      this.elements.forEach(element => {
        element.quantity = this.roundQuantity(element.quantity);
      });
    }
    this.providers = return_elements[1];
    this.total_order = return_elements[2];
    this.total_providers = return_elements[3];
    this.providersServices.getTotalCartElements(this.globals.restaurant_uid, this.globals.user_uid);
    this.checkOrderValidation();
  }

  async finishSendAsync() {
    var return_elements = await this.providersServices.getElementsCart(this.globals.restaurant_uid, this.globals.user_uid);
    this.total_order = return_elements[2];
    this.total_providers = return_elements[3];
    this.providersServices.getTotalCartElements(this.globals.restaurant_uid, this.globals.user_uid);
  }

  calculateRow(i, p) {
    this.elements[i].quantity = this.roundQuantity(this.elements[i].quantity);
    this.elements[i].sub_total = this.globals.calculatePrice(this.elements[i].price, this.elements[i].quantity, this.elements[i].measurement);
    this.elements[i].total = this.globals.calculatePrice(this.elements[i].price_tax, this.elements[i].quantity, this.elements[i].measurement);
    this.calculateTotal(p);
    this.total_order = 0;
    this.calculateTotalOrders();
    this.checkOrderValidation(); // Añadir esta línea
  }

  roundQuantity(value) {
    const numberValue = parseFloat(value) || 0;
    return Math.round(numberValue * 1000) / 1000;
  }

  calculateTotal(p) {
    this.providers[p].total = 0;
    this.providers[p].sub_total = 0;
    for (let element of this.elements) {
      if (element.provider_uid == this.providers[p].uid) {
        if (element.total > 0) {
          this.providers[p].total = this.providers[p].total + element.total;
          this.providers[p].sub_total = this.providers[p].sub_total + element.sub_total;
        }
      }
    }
  }

  calculateTotalOrders() {
    this.providers.forEach((item, index) => {
      this.calculateTotalrow(index);
    });
  }

  calculateTotalrow(p) {
    this.providers[p].total = 0;
    for (let element of this.elements) {
      if (element.provider_uid == this.providers[p].uid) {
        if (element.total > 0) {
          this.providers[p].total = this.providers[p].total + element.total;
          this.total_order += this.providers[p].total;

        }
      }
    }
  }

  delete(index, p) {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('instant-eliminar-elemento'),
      message: this.translate.instant('instant-seguro-quieres-eliminarlo'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {

            this.deleteCart(this.elements[index].uid);
            this.elements.splice(index, 1);
            this.getElementsAsync();
            this.calculateTotal(p);
          }
        }
      ]
    });
    alert.present();

  }

  async providerOrders(type, provider, via) {
    // Validar según el tipo de pedido
    if (type === 'all') {
      // Para todos los pedidos, verificar que ningún proveedor con email tenga elementos con cantidad 0
      if (!this.canPlaceAllOrders()) {
        let alert = this.alertCtrl.create({
          title: this.translate.instant('general-atencion'),
          message: this.translate.instant('provider-order-cart-elementos-cantidad-cero'),
          buttons: [
            {
              text: this.translate.instant('general-ok'),
              handler: () => { }
            }
          ]
        });
        alert.present();
        return;
      }
    } else {
      // Para un proveedor específico, solo verificar ese proveedor
      if (this.providerHasZeroQuantityElements(provider.uid)) {
        let alert = this.alertCtrl.create({
          title: this.translate.instant('general-atencion'),
          message: this.translate.instant('provider-order-cart-elementos-cantidad-cero'),
          buttons: [
            {
              text: this.translate.instant('general-ok'),
              handler: () => { }
            }
          ]
        });
        alert.present();
        return;
      }
    }

    //init
    var list = [];
    var notes = '';
    var provider_static = '';
    var uid_delibery_note = '';
    //var uid_provider = '';
    var provider_email = '';
    var provider_phone = '';
    //type
    if (type == 'all') {
      //
      if (this.providers != undefined) {
        for (let _provider of this.providers) {
          if (_provider.email.length > 0) {
            _provider.state = 'sending';
            for (let element of this.elements) {
              if (_provider.uid == element.provider_uid && _provider.email != '') {
                //create data provider_order
                // ✅ Validación: Asegurar que valores numéricos sean válidos para evitar NaN
                list.push({
                  measurement: element.measurement,
                  name: element.name,
                  price: parseFloat(element.price) || 0,
                  quantity: parseFloat(element.quantity) || 0,
                  tax: parseFloat(element.tax) || 0,
                  type: element.type,
                  uid: element.uid,
                  sub_total: parseFloat(element.sub_total) || 0,
                  total: parseFloat(element.total) || 0,
                  lots: '',
                  ean: element.ean || ''
                });
                //eliminar
                await this.deleteCart(element.uid);
              }
            }
            notes = _provider.notes;
            provider_static = _provider.name_static;
            //uid_provider = _provider.uid;
            provider_email = _provider.email;
            provider_phone = _provider.phone;
            //insert
            this.insertProviderOrder(list, notes, provider_static, uid_delibery_note, _provider.uid, provider_email, provider_phone, _provider.total, _provider.sub_total, via);
            list = [];
          }
        }
      }
    } else {
      //
      var index = this.providers.findIndex(item => item.uid == provider.uid);
      this.providers[index].state = 'sending';
      //
      for (let element of this.elements) {
        if (provider.uid == element.provider_uid && provider.email.length > 0) {
          //create data provider_order
          // ✅ Validación: Asegurar que valores numéricos sean válidos para evitar NaN
          list.push({
            measurement: element.measurement,
            name: element.name,
            ean: element.ean || '',
            price: parseFloat(element.price) || 0,
            quantity: parseFloat(element.quantity) || 0,
            tax: parseFloat(element.tax) || 0,
            type: element.type,
            uid: element.uid,
            sub_total: parseFloat(element.sub_total) || 0,
            total: parseFloat(element.total) || 0,
            lots: ''
          });
          //eliminar
          await this.deleteCart(element.uid);
        }
      }
      if (provider.email.length > 0 && provider.state != 'send') {
        notes = provider.notes;
        provider_static = provider.name_static;
        //uid_provider = provider.uid;
        provider_email = provider.email;
        provider_phone = provider.phone;
        this.insertProviderOrder(list, notes, provider_static, uid_delibery_note, provider.uid, provider_email, provider_phone, provider.total, provider.sub_total, via);
      }
    }
  }


  insertProviderOrder(list, notes, provider_static, uid_delibery_note, uid_provider, provider_email, provider_phone, total, sub_total, via) {
    // ✅ Validación: Asegurar que sub_total y total sean números válidos para evitar NaN
    const validatedSubTotal = parseFloat(sub_total) || 0;
    const validatedTotal = parseFloat(total) || 0;

    this.providersServices.afs.collection('provider_order').add({
      'UID_RESTAURANT': this.globals.restaurant_uid,
      'UID_USER': this.globals.user_uid,
      'created_at': new Date(),
      'delivery_note': false,
      'list': list,
      'sub_total': validatedSubTotal,
      'total': validatedTotal,
      'notes': notes,
      'provider_email': provider_email,
      'provider_phone': provider_phone,
      'provider_static': provider_static,
      'state': 'send',
      'sended_by': via,
      'uid_delibery_note': uid_delibery_note,
      'uid_provider': uid_provider,
      'waiter': this.globals.waiter,
      'user': {
        'uid': this.globals.user_uid,
        'name': this.globals.user_name,
        'email': this.globals.user_email
      },
      'provider': this.providers.find(x => x.uid == uid_provider),
      'currency': this.globals.user_currency
    }).then(async doc => {
      this.globals.GAtrackView('ProviderOrders', 'ProviderOrders - Provider order - Create', this.globals.restaurant.email, 'Create/Update', 'Create provider order', 'ProviderOrders', provider_email);
      //change state
      var index = this.providers.findIndex(x => x.uid == uid_provider);
      this.providers[index].state = 'send';
      //recalculos
      this.finishSendAsync();
      //enviar a cloud functions _emails
      var currency = getCurrencySymbol(this.globals.user_currency, 'narrow', 'es');
      //
      if (via === 'email') {
        this.providersServices.afs.collection('_emails').add({
          'UID_RESTAURANT': this.globals.restaurant_uid,
          'type': 'provider_order',
          'order_uid': doc.id,
          'email': this.globals.restaurant.email,
          'currency': currency
        });
        this.analyticsService.trackingExpStock('provider_order', this.globals.tracking_exp['provider_order'], doc.id);
      } else {//phone
        var whatsapp_order = "https://wa.me/" + provider_phone.toString() + "?text=*" + this.translate.instant('general-pedido') + "*%0A" + this.globals.restaurant.company;
        //generate list
        for (let element of list) {
          var _ean = element.ean != '' ? "%20(" + element.ean + ")" : "";
          whatsapp_order += "%0A*%20" + element.quantity + "x%20" + element.measurement + "%20" + element.name + _ean
        }
        //add notes
        if (notes !== '') {
          whatsapp_order += "%0A" + this.translate.instant('provider-order-comentario') + ":%0A" + notes;
        }
        //replace spaces
        whatsapp_order = whatsapp_order.replace(/ /g, "%20");
        if (this.globals.so_mobile) {
          window.location.assign(whatsapp_order);
        } else {
          window.open(whatsapp_order, '_blank');
        }
        this.analyticsService.trackingExpStock('provider_order', this.globals.tracking_exp['provider_order'], doc.id);
      }
    });
  }

  async deleteCart(element_uid) {
    await this.providersServices.deleteCartElements(this.globals.restaurant_uid, element_uid, this.globals.user_uid);
  }

  async emptyCart() {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('general-vaciar-cesta'),
      message: this.translate.instant('instant-seguro-quieres-vaciar-cesta'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.globals.GAtrackView('ProviderOrders', 'ProviderOrders - Cart - Delete', this.globals.restaurant.email, 'Delete', 'Delete cart', 'ProviderOrders', '');
            this.providersServices.emptyCart(this.globals.restaurant_uid, this.globals.user_uid);
            this.getElements();
          }
        }
      ]
    });
    alert.present();
  }

  openStock() {
    this.navCtrl.push(StockListPage);
  }

  openOrderList() {
    this.navCtrl.push(ProviderOrderListPage);
  }

  async editProver(_provider) {
    var provider = await this.providersServices.getProvider(_provider.uid);
    this.navCtrl.push(ProvidersCreateDataPage, {
      update_state: true,
      provider_uid: provider.UID,
      name: provider.name,
      contact_name: provider.contact_name,
      nif: provider.nif,
      email: provider.email,
      phone: provider.phone,
      country: provider.country,
      province: provider.province,
      city: provider.city,
      address: provider.address,
      fixed_phone: provider.fixed_phone,
      web: provider.web,
      cp: provider.cp,
      no_provider: provider.no_provider,
      observations: provider.observations,
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/providers/orders/provider-order-cart/provider-order-cart.ts